/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup } from './CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup';
import {
    CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupFromJSON,
    CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupFromJSONTyped,
    CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupToJSON,
} from './CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface GetMedicalSystemSetupTemplate
 */
export interface GetMedicalSystemSetupTemplate {
    /**
     * 
     * @type {string}
     * @memberof GetMedicalSystemSetupTemplate
     */
    targetSystemId?: string;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof GetMedicalSystemSetupTemplate
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup}
     * @memberof GetMedicalSystemSetupTemplate
     */
    previousMedicalSystemSetup?: CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup | null;
    /**
     * 
     * @type {string}
     * @memberof GetMedicalSystemSetupTemplate
     */
    $type?: GetMedicalSystemSetupTemplateTypeEnum;
}


/**
 * @export
 */
export const GetMedicalSystemSetupTemplateTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoGetMedicalSystemSetupTemplatePtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.GetMedicalSystemSetupTemplate, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetMedicalSystemSetupTemplateTypeEnum = typeof GetMedicalSystemSetupTemplateTypeEnum[keyof typeof GetMedicalSystemSetupTemplateTypeEnum];



/**
 * Check if a given object implements the GetMedicalSystemSetupTemplate interface.
 */
export function instanceOfGetMedicalSystemSetupTemplate(value?: unknown): value is GetMedicalSystemSetupTemplate {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetMedicalSystemSetupTemplateTypeEnum)[0];
}

export function GetMedicalSystemSetupTemplateFromJSON(json: any): GetMedicalSystemSetupTemplate {
    return GetMedicalSystemSetupTemplateFromJSONTyped(json, false);
}

export function GetMedicalSystemSetupTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMedicalSystemSetupTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSystemId': json['targetSystemId'] == null ? undefined : json['targetSystemId'],
        'taskType': json['taskType'] == null ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'previousMedicalSystemSetup': json['previousMedicalSystemSetup'] == null ? undefined : CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupFromJSON(json['previousMedicalSystemSetup']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function GetMedicalSystemSetupTemplateToJSON(value?: GetMedicalSystemSetupTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'targetSystemId': value['targetSystemId'],
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        'previousMedicalSystemSetup': CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupToJSON(value['previousMedicalSystemSetup']),
        '$type': value['$type'],
    });
}

